module.exports = __webpack_public_path__ + "img/pic_price.6cd558d9.png";